(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function(){
    /* this watches the volume discounts container to see if a volume discount will be injected by the app
    if there is, use it to change discounts  */
  
    const elementNode = document.querySelector('.docapp-volume-discounts-promo');
    
    function calculateDiscountedPrice(regularPrice, discount) {
      return '£' + (parseFloat(regularPrice) - parseFloat(discount)).toFixed(2)
    }
    
    if(!elementNode) return
   
    const regularPrice = elementNode.dataset.price  
    const observer = new MutationObserver(function(mutationList, observer) {
      if( !document.querySelector('.docapp-volume-discounts-promo-table') ) return
      
      document.querySelectorAll('.docapp-volume-discounts-promo-table-item').forEach( discountRow => { 
        discountSpan = discountRow.querySelector('span')
        if(!discountSpan) return
        discount = discountSpan?.getAttribute('ge-data-original-price') ?? 0;
        discountSpan.innerHTML = calculateDiscountedPrice(regularPrice, discount)      
      })        
      observer.disconnect();
    });
  
    // Call the observe function by passing the node you want to watch with configuration options
    observer.observe(elementNode, {
      attributes: false, 
      childList: true, 
      subtree: false 
    });
  
  })() 

  } catch(e) { console.error(e); }
})();
})();
